import {getInbox} from '@/api/maintain/plant/list'

// initial state
const state = {
    msgList:null,
    unRead:0,
    isNoticeBox:false
}

// getters
const getters = {
    msgList: state => state.msgList,
    unRead:state=>{
        if(state.msgList){
            for(let attr in state.msgList){
                if(state.msgList[attr].read==false){
                    state.unRead++
                }
            }
        }
        return state.unRead
    },
    isNoticeBox:state=>state.isNoticeBox
}

// actions
const actions = {
    GETMSGLIST({commit}){
        commit('GET_MSGLIST',null)
        return new Promise((resolve,reject)=>{
            getInbox().then(response=>{
                commit('GET_UNREAD',0)
                commit('GET_MSGLIST',response)
                resolve()
            }).catch(error=>{
                reject(error)
            })
        })
    }
}
// mutations
const mutations = {
    GET_MSGLIST:(state,item)=>{
        state.msgList=item
    },
    GET_UNREAD:(state,item)=>{
        state.unRead=item
    },
    GET_ISNOTICEBOX:(state,item)=>{
        state.isNoticeBox=item
    }
}

export default {
    namespaced: true,
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/inbox.js